import React, { useState, useEffect } from 'react';
import { Newspaper, Calendar, User, ArrowRight } from 'lucide-react';
import { blogAPI } from '../services/api';
import './Blog.css';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPosts();
  }, []);

  const loadPosts = async () => {
    setLoading(true);
    try {
      const data = await blogAPI.getAllPosts(20);
      setPosts(data);
    } catch (error) {
      console.error('Error loading blog posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ro-RO', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="blog-page">
      <section className="blog-hero">
        <div className="container">
          <h1 className="page-title">Noutăți & Blog</h1>
          <p className="page-subtitle">
            Rămâi la curent cu ultimele noutăți despre serviciile noastre
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {loading ? (
            <div className="loading-state">Se încarcă articolele...</div>
          ) : (
            <div className="blog-grid">
              {posts.map((post) => (
                <article key={post.id} className="blog-card card">
                  {post.image && (
                    <div className="blog-image">
                      <img src={post.image} alt={post.title} />
                    </div>
                  )}
                  <div className="blog-content">
                    <span className="blog-category">{post.category}</span>
                    <h2 className="blog-title">{post.title}</h2>
                    <p className="blog-excerpt">{post.excerpt}</p>

                    <div className="blog-meta">
                      <div className="blog-meta-item">
                        <Calendar size={16} />
                        <span>{formatDate(post.publishedAt)}</span>
                      </div>
                      <div className="blog-meta-item">
                        <User size={16} />
                        <span>{post.author}</span>
                      </div>
                    </div>

                    <a href={`/blog/${post.id}`} className="blog-read-more">
                      Citește mai mult
                      <ArrowRight size={18} />
                    </a>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;
